/* DM TELCO — native header menu behaviour.
   Desktop: hover opens/closes the rail dropdowns (Dawn's details/summary
   is click-only by default). Gated to viewports with a real hover pointer,
   so touch devices keep tap-to-open and keyboard use is untouched
   (toggling the open attribute fires the toggle event Dawn's HeaderMenu
   listens to for its bottom-border positioning).

   Owner, 2026-10-15: "when I hover over the products at the very top, and try
   to get to the all products area ... A lot of the time it disappears before
   I have the ability to click". With the staff items the rail wraps onto two
   rows, so the pointer crosses the second row (About, Admin, ...) on its way
   down to the panel. Two rules make that easy:
   - an open panel waits CLOSE_DELAY_MS after the pointer leaves before it
     closes, and coming back in time keeps it open;
   - while one panel is open, another (About) opens only if the pointer RESTS
     on it for SWITCH_DELAY_MS, so passing over it does not take over. */
(function () {
  var hoverMedia = window.matchMedia('(min-width: 990px) and (hover: hover)');
  var CLOSE_DELAY_MS = 500;
  var SWITCH_DELAY_MS = 300;

  function init() {
    var all = Array.prototype.slice.call(document.querySelectorAll('.header__inline-menu header-menu > details'));

    function show(details) {
      all.forEach(function (other) {
        if (other !== details && other.hasAttribute('open')) hide(other);
      });
      clearTimeout(details._dmClose);
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
        var s = details.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', 'true');
      }
    }
    function hide(details) {
      clearTimeout(details._dmClose);
      clearTimeout(details._dmOpen);
      details.removeAttribute('open');
      var s = details.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', 'false');
    }

    all.forEach(function (details) {
      details.addEventListener('mouseenter', function () {
        if (!hoverMedia.matches) return;
        clearTimeout(details._dmClose);
        clearTimeout(details._dmOpen);
        if (details.hasAttribute('open')) return;
        var another = all.some(function (other) { return other !== details && other.hasAttribute('open'); });
        if (another) details._dmOpen = setTimeout(function () { show(details); }, SWITCH_DELAY_MS);
        else show(details);
      });

      // Clicking "Products" goes to All Products (owner 2026-10-15: "if someone actually clicks on
      // products ... does exactly the same thing as clicking all products"). With a mouse only: on a
      // touch screen, or from the keyboard, it still opens the panel, the only way to the categories.
      var summary = details.querySelector('summary');
      if (summary) summary.addEventListener('click', function (e) {
        if (!hoverMedia.matches || e.detail === 0) return;
        var allLink = details.querySelector('.dm-cascade__all a[href]');
        if (!allLink) return;
        e.preventDefault();
        (window.dmMenuGo || function (url) { window.location.href = url; })(allLink.href);
      });

      details.addEventListener('mouseleave', function () {
        if (!hoverMedia.matches) return;
        clearTimeout(details._dmOpen);
        clearTimeout(details._dmClose);
        if (details.hasAttribute('open')) details._dmClose = setTimeout(function () { hide(details); }, CLOSE_DELAY_MS);
      });
    });
  }

  /* One line (owner 2026-10-15: "I would like an auto fit in one line ... we might add things more
     later"). Measured, not counted: from full size, step the text and spacing down (data-fit 1..4, the
     sizes are in assets/dm-menu.css) until every item sits on the first line. If even the smallest step
     does not fit (a narrow window), it wraps as before; the panels above cope with two rows. */
  var desktop = window.matchMedia('(min-width: 990px)');
  var FIT_STEPS = 4;
  function fit() {
    var ul = document.querySelector('.header__inline-menu .list-menu--inline');
    if (!ul) return;
    var header = ul.closest('header');
    ul.removeAttribute('data-fit');
    if (header) header.classList.remove('dm-menu-wide');
    if (!desktop.matches) return;
    var items = Array.prototype.filter.call(ul.children, function (li) { return li.offsetParent !== null; });
    if (items.length < 2) return;
    var oneLine = function () {
      var top = items[0].getBoundingClientRect().top;
      return items.every(function (li) { return Math.abs(li.getBoundingClientRect().top - top) < 2; });
    };
    var steps = function () {
      ul.removeAttribute('data-fit');
      for (var step = 1; step <= FIT_STEPS && !oneLine(); step++) ul.setAttribute('data-fit', String(step));
      return oneLine();
    };
    // Last resort (owner 2026-10-15, "a variable header for the admins ... so the admins can still have
    // one line"): when even the smallest text does not fit at the page width, the header (and its
    // dropdowns, so they stay lined up) may use more of a wide screen (dm-menu-wide in dm-menu.css).
    if (!steps() && header) {
      header.classList.add('dm-menu-wide');
      steps();
    }
  }
  var fitQueued = false;
  function fitSoon() {
    if (fitQueued) return;
    fitQueued = true;
    (window.requestAnimationFrame || setTimeout)(function () { fitQueued = false; fit(); });
  }

  function start() {
    init();
    fit();
    window.addEventListener('resize', fitSoon);
    window.addEventListener('load', fitSoon);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitSoon);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  window.dmMenuFit = fit; // for tests
})();
